import React from "react";

import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import BecomeDriverSection from "../components/UI/BecomeDriverSection";
import driveImg from "../assets/all-images/drive.jpg";
import OurMembers from "../components/UI/OurMembers";
import OurClients from "../components/UI/OurClinets";
import "../styles/about.css";
import AboutMe from "../components/UI/aboutMe";

const About = () => {
  return (
    <Helmet title="About">
      <CommonSection title="About Us" />
      <AboutMe aboutClass="aboutPage"/>
      <AboutSection aboutClass="aboutPage" />

      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <div className="about__page-img">
                <img src={driveImg} alt="" className="w-100 rounded-3" />
              </div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <div className="about__page-content">
                <h2 className="section__title">
                  We Are Committed To Provide Safe Ride Solutions
                </h2>

                <p className="section__description">
                At UNIONCABS, our unwavering commitment is to provide safe and reliable ride solutions for every journey. Your well-being is our top priority, and we go the extra mile to ensure that every ride with us is a secure and comfortable experience.
                </p>

                <p className="section__description">
                  <b>Stringent Safety Measures:</b> Our commitment begins with rigorous safety protocols. From regular vehicle maintenance to thorough driver background checks, we leave no stone unturned in ensuring the highest standards of safety. <br />
                  <b>Experienced and Professional Drivers:</b>Trust in the expertise of our experienced and professional drivers. They are not only skilled behind the wheel but are also committed to delivering a smooth and secure journey for every passenger. <br />
                  <b>Clean and Well-Maintained Fleet:</b>Step into a clean and well-maintained vehicle for every ride. Our commitment to cleanliness extends to the interiors of our cars, providing you with a hygienic and pleasant environment. <br />
                </p>

                <div className=" d-flex align-items-center gap-3 mt-4">
                  <span className="fs-4">
                    <i class="ri-phone-line"></i>
                  </span>

                  <div>
                    <h6 className="section__subtitle">Need Any Help?</h6>
                    <h4>+919506726327</h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <BecomeDriverSection />

      <section>
        <Container>
        <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle">Experts</h6>
              <h2 className="section__title">Our Members</h2>
            </Col>
            <OurMembers />
          </Row>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle">Clients</h6>
              <h2 className="section__title">Our Clients</h2>
            </Col>
            <OurClients />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;
